interface ConnectionStatusBannerProps {
  getToken: () => Promise<string>;
}

/**
 * The banner is intentionally disabled: MS365 is an optional integration and
 * we do not want to prompt every user to connect it. The component remains
 * in the tree so re-enabling it later is a one-line change.
 */
export function ConnectionStatusBanner(_props: ConnectionStatusBannerProps) {
  return null;
}
